import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Post from './post'

class Gallery extends Component {
  render() {
    let artwork = _.map(this.props.posts, (post, key) => {
      let _FeaturedMedia

      if (post._embedded['wp:featuredmedia']) {
        _FeaturedMedia = post._embedded['wp:featuredmedia']
      }

      if (_FeaturedMedia) {
        return (
          <Post title={ post.title.rendered }
                image={ _FeaturedMedia[0].media_details.sizes.medium.source_url }
                key={ key }
                />
        )
      } else {
        console.log('no image', post)
      }
    })

    return (
      <div className="gallery">
        { artwork }
      </div>
    )
  }
}

Gallery.propTypes = {
  posts: PropTypes.array.isRequired
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/index.js